/**
 * Chat Channel List Component
 * Sidebar showing available channels organized by department
 */

import React from 'react';
import './ChatChannelList.css';

const ChatChannelList = ({ channels, activeChannel, onChannelSelect, unreadCounts, stakeholders, stakeholdersLoading }) => {
  return (
    <div className="chat-channel-list">
      <div className="channel-list-header">
        <h3>Channels</h3>
        {stakeholdersLoading && (
          <span className="channel-list-loading" aria-label="Loading channels">Loading…</span>
        )}
      </div>
      <div className="channel-list">
        {channels.map(channel => {
          const channelStakeholders = stakeholders?.[channel.id] || [];
          const isActive = activeChannel === channel.id;
          
          return (
            <div key={channel.id} className="channel-department">
              <button
                className={`department-header ${isActive ? 'active' : ''}`}
                onClick={() => onChannelSelect(channel.id)}
                disabled={stakeholdersLoading}
              >
                <span className="channel-icon">{channel.icon}</span>
                <span className="department-name">{channel.name}</span>
                {unreadCounts[channel.id] > 0 && (
                  <span className="unread-badge">{unreadCounts[channel.id]}</span>
                )}
              </button>
              {stakeholdersLoading ? (
                <div className="stakeholders-list stakeholders-list-loading">
                  <span className="stakeholder-item-skeleton">Loading…</span>
                </div>
              ) : channelStakeholders.length > 0 ? (
                <div className="stakeholders-list">
                  {channelStakeholders.map(stakeholder => (
                    <button
                      key={stakeholder.id}
                      className={`stakeholder-item ${isActive ? 'active' : ''}`}
                      onClick={() => onChannelSelect(channel.id)}
                    >
                      <span className="stakeholder-name">
                        {stakeholder.name} {stakeholder.role && `(${stakeholder.role})`}
                      </span>
                    </button>
                  ))}
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ChatChannelList;







